import { defineRouting } from "next-intl/routing";

export const routing = defineRouting({
  // A list of all locales that are supported
  locales: ["en", "es", "fr"],

  // Used when no locale matches
  defaultLocale: "en",

  // Always show locale prefix in URLs
  localePrefix: "always",

  // Hreflang `<link>` tags are emitted per-page via Next.js `alternates.languages`
  // metadata. Disable next-intl's `Link`-header alternates so the un-prefixed
  // (redirecting) URL is not advertised as an `x-default` alternate.
  alternateLinks: false,
});

export const languages = {
  en: "English",
  es: "Spanish",
  fr: "French",
} as const;
